import { useTranslations } from 'next-intl'

import type { ImageProps } from '~/components/atoms/Image/Image'
import useReportSignUp from '~/hooks/useReportSignUp'

import PremiumContentBanner from './PremiumContentBanner'

interface PremiumContentBannerReportProps {
  image?: ImageProps
  /**
   * Optional per-report copy from Sanity. Blank or missing values fall back to
   * the default translated wording, so clearing a field in the CMS restores the
   * default rather than rendering nothing.
   */
  overrides?: {
    title?: string
    description?: string
    bullets?: string[]
  }
}

export default function PremiumContentBannerReport({
  image,
  overrides,
}: PremiumContentBannerReportProps) {
  const t = useTranslations('premiumContent')
  const buttonText = t('createFreeAccount')
  const { openReportSignUp } = useReportSignUp()

  const handleClick = () => {
    openReportSignUp(image)
  }

  // Bullets are all-or-nothing: a partial list would mix editor copy with the
  // translated defaults, so any non-empty override replaces the whole list.
  const componentText = {
    title: overrides?.title || t('reports.title'),
    text: overrides?.description || t('reports.description'),
    bullets: overrides?.bullets?.length
      ? overrides.bullets
      : [t('reports.benefit1'), t('reports.benefit2'), t('reports.benefit3')],
  }

  return (
    <PremiumContentBanner
      buttonText={buttonText}
      clickHandler={handleClick}
      componentText={componentText}
    />
  )
}
